import { roles } from "shared/constants/Constants";

const driverManagementRoutes = {
  dashboard: [
    {
      path: "waiver",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "waiver" */
          "feature/driver-management/dashboard/Waiver.js"
        ),
      authorized: [
        roles.HUB_MANAGER,
        roles.ADMIN,
        roles.SENIOR_DRIVER_MANAGER,
        roles.DRIVER_MANAGER,
      ],
      sidebarGroup: "requestList",
      sidebarLabel: "Waiver",
      countKey: "waiver_count",
    },
    {
      path: "rental_scheme_change",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "rental-scheme-change-request" */
          "feature/driver-management/dashboard/HMRentalSchemeChangeRequest.js"
        ),
      authorized: [
        roles.HUB_MANAGER,
        roles.ADMIN,
        roles.SENIOR_DRIVER_MANAGER,
        roles.DRIVER_MANAGER,
      ],
      sidebarGroup: "requestList",
      sidebarLabel: "Scheme Change",
      countKey: "scheme_change",
    },
    {
      path: "maintenance",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "maintenance-request" */
          "feature/driver-management/dashboard/HMMaintenanceRequest.js"
        ),
      authorized: [
        roles.HUB_MANAGER,
        roles.ADMIN,
        roles.SENIOR_DRIVER_MANAGER,
        roles.FLEET_MANAGER,
        roles.FLEET_GENERAL_MANAGER,
        roles.DRIVER_MANAGER,
      ],
      sidebarGroup: "requestList",
      sidebarLabel: "Maintenance",
      countKey: "maintenance_count",
    },
    {
      path: "car-drop",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "car-drop-request" */
          "feature/driver-management/dashboard/HMCarDropRequest.js"
        ),
      authorized: [
        roles.HUB_MANAGER,
        roles.ADMIN,
        roles.SENIOR_DRIVER_MANAGER,
        roles.DRIVER_MANAGER,
      ],
      sidebarGroup: "requestList",
      sidebarLabel: "Car Drop",
      countKey: "car_drop_count",
    },
    {
      path: "car-change",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "car-change-request" */
          "feature/driver-management/dashboard/HMCarChangeRequest.js"
        ),
      authorized: [
        roles.HUB_MANAGER,
        roles.ADMIN,
        roles.SENIOR_DRIVER_MANAGER,
        roles.DRIVER_MANAGER,
      ],
      sidebarGroup: "requestList",
      sidebarLabel: "Car Change",
      countKey: "car_change_count",
    },
    {
      path: "recovery",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "recovery-request" */
          "feature/driver-management/dashboard/HMCarRecoveryRequest.js"
        ),
      authorized: [
        roles.HUB_MANAGER,
        roles.ADMIN,
        roles.SENIOR_DRIVER_MANAGER,
        roles.DRIVER_MANAGER,
      ],
      sidebarGroup: "requestList",
      sidebarLabel: "Recovery",
      countKey: "recovery_request_count",
    },
    {
      path: "driver-return",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "driver-return-request" */
          "feature/driver-management/dashboard/DriverReturnRequest.js"
        ),
      authorized: [
        roles.ONBOARDING,
        roles.HUB_MANAGER,
        roles.ADMIN,
        roles.DRIVER_MANAGER,
        roles.SENIOR_DRIVER_MANAGER,
        roles.VERIFICATION,
      ],
      sidebarGroup: "requestList",
      sidebarLabel: "Driver Return",
      countKey: "driver_return_count",
    },
    {
      path: "penalty",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "penalty" */
          "feature/driver-management/dashboard/Penalty.js"
        ),
      authorized: [
        roles.HUB_MANAGER,
        roles.ADMIN,
        roles.SENIOR_DRIVER_MANAGER,
        roles.DRIVER_MANAGER,
      ],
      sidebarGroup: "requestList",
      sidebarLabel: "Penalty",
      countKey: "pending_penalty_request_count",
    },
    {
      path: "images-upload-history",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "images-upload-history" */
          "feature/driver-management/dashboard/ImagesUploadHistory.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "requestList",
      sidebarLabel: "Upload History",
      countKeyAllFleet: true,
    },

    {
      path: "recovery_penalty",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "recovery-penalty" */
          "feature/driver-management/dashboard/RecoveryPenalty.js"
        ),
      authorized: [],
    },
    {
      path: "maintenance_penalty",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "maintenance-penalty" */
          "feature/driver-management/dashboard/MaintenancePenality.js"
        ),
      authorized: [],
    },

    {
      path: "week_off",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "week-off-request" */
          "feature/driver-management/dashboard/HMWeekOffRequest.js"
        ),
      authorized: [],
    },
    {
      path: "requests_dmAssign",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "dm-assign-request" */
          "feature/driver-management/dashboard/DmAssign.js"
        ),
      authorized: [],
    },
  ],
  standalone: [
    {
      path: "/driver-details-edit/:driverID/history",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "request-history-dashboard" */
          "feature/driver-management/dashboard/RequestHistoryDashboard"
        ),
      protected: true,
    },
  ],
};

export default driverManagementRoutes;
